import styled from "styled-components/native";
import { color, wpdColor } from "../theme";
import AmountIndicator from "./amountIndicator";

export const AmountIndicatorDark = styled(AmountIndicator)`
  background-color: ${color.darker};
  color: ${wpdColor.backgroundLighter};
`;
